import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import Image from "../../elements/image";
import cookie from "react-cookies";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import {  useDispatch } from 'react-redux';
import PrimaryButton from "../../elements/primary-button";
import { mobileIs, formatDecimal } from "../../utils/siteUtils";
import Loader from "../../elements/loader";
import Loading from "../../elements/loading";
import Toast from "../../elements/toast";
import WaterFallItem from "./water-fall-item";
import webcookie from "../../utils/webcookie";
import { apiAsia } from "../../utils/api-asia";
import "./style.scss";
import classNames from "classnames";
let loadId = []
const WaterFall = props => {
  const { lang, fields, page } = props;
  const isAR = page?.fields?.rtl?.value;
  const { des, desMobile, list, titleSize, desSize, colorScheme, buttonText, iconName, paddingAboveBottom, paddingAboveTop } = fields;
  const isMobile = mobileIs();
  const rootEl = useRef(null);
  const timer = useRef();
  const timerToast = useRef();
  const likeTimer = useRef();
  const [masonry, setMasonry] = useState(false);
  const [loadingShow, setLoadingShow] = useState(false);
  const [total, setTotal] = useState(6);
  const [loadedItem,setLoadedItem] = useState({});
  const [toastTip,setToastTip] = useState("");
  const [toastShow, setToastShow] = useState(false);
  const [listData, setListData] = useState(list);
  const [playerIndex, setPlayerIndex] = useState();
  const [oldPlayerIndex, setOldPlayerIndex] = useState();
  const [showBtn, setShowBtn] = useState(true);
  const [isClick, setIsClick] = useState(false);
  const dispatch = useDispatch()
  const itemLoader = (id, index) => {
    let newData = loadedItem;
    if( newData[id] ){ return false }
    newData[id] = id;
    setLoadedItem(newData);
    if( Object.keys(loadedItem).length == total ){
      setTimeout(v=>{
        let winHeight = window.innerHeight || document.documentElement.clientHeight;
        let dom = rootEl.current.getBoundingClientRect();
        if( Math.abs(dom.top) > dom.height-winHeight ){
          // setTotal(total+6)
        }
      },2000)
    }
  }
  const videoPlayPressed = (index) => {
    setOldPlayerIndex(playerIndex)
    setPlayerIndex(index)
  }
  const handleScroll = e => {
    let winHeight = window.innerHeight || document.documentElement.clientHeight;
    let dom = rootEl.current.getBoundingClientRect();
    if( Math.abs(dom.top) > dom.height-winHeight ){
      var arr = Object.keys(loadedItem); 
      if( arr.length == total){
        // setTotal(total+6)
      }
      if( total>list.length || total === list.length){
        window.removeEventListener("scroll", handleScroll);
      }
    }
  };
  const getMacy = () => {
    if (masonry) {
        masonry.reInit()
    } else {
        let masonry;
        if(isAR){
        masonry = window.MacyAr({
          container: '.water-fall__list', // 图像列表容器
          trueOrder: false,
          waitForImages: false,
          useOwnImageLoader: false,
          debug: true,
          margin: { x: isMobile ? 15: 30, y: isMobile ? 20: 40 },
          columns: isMobile ? 2 : 3, 
        })
      }else{
        masonry = window.Macy({
          container: '.water-fall__list', // 图像列表容器
          trueOrder: false,
          waitForImages: false,
          useOwnImageLoader: false,
          debug: true,
          margin: { x: isMobile ? 15: 30, y: isMobile ? 20: 40 },
          columns: isMobile ? 2 : 3, 
        })
      }
      timer.current = setInterval(() => {
        if(total < list.length){
          masonry.reInit()
        }else{
          clearInterval(timer.current)
        }
      },2000)
      setMasonry(masonry)
    }
  }
  const like = (id,index,cancel) => {
    if(webcookie.getCookie("newCode"+lang) ){
      likeFun(id,index,cancel)
    }else{
      dispatch({ type: 'CHANGE_COOKIES', val: true })
    }
  }
  const likeFun = (id,index,cancel) => {
    if(loadId.indexOf(id)!=-1){return false;}
    clearTimeout(timerToast.current)
    let params = {
      cookieCode:  webcookie.getCookie("newCode"+lang) ,
      itemId: id,
      cancel: cancel,
      language: lang
    }
    loadId.push(id)
    apiAsia.waterFall.like(params).then(res => {
      if (!!res[0] && res[0] == 'true') {
        let data = JSON.parse(JSON.stringify(listData));
        if(cancel){
          data[index].like--
        }else{
          if(!data[index].like) data[index].like = 0
          data[index].like++
        }
        data[index].isLike = !cancel;
        if(data[index].like>999){
          data[index].likeOther = formatDecimal(data[index].like/1000,1)+'k'
        }
        setListData(data)
        loadId.splice(loadId.indexOf(id),1)
      }else {
        if( res[1] && res[1].data=="ip error"){
          setToastTip("今天点赞次数已超上限")
        }else{
          setToastTip("点赞失败")
        }
        setToastShow(true)
        loadId.splice(loadId.indexOf(id),1)
        timerToast.current = setTimeout(()=>{
          setToastShow(false)
        },3000)
      }
    })
    .catch(err => {
      setToastShow(true)
      setToastTip("点赞失败")
      loadId.splice(loadId.indexOf(id),1)
      timerToast.current = setTimeout(()=>{
        setToastShow(false)
      },3000)
    });
  }
  const buttonProps = {
    buttonText: buttonText,
    colorScheme: colorScheme,
    iconName: iconName,
    callback: evt => {
      setIsClick(true)
      setTimeout(v=>{
        if(total < list.length) {
          setTotal(total+6)
          if(total+6 > list.length || total+6 === list.length) {
            setShowBtn(false)
          }
        } else {
          setShowBtn(false)
        }
        setIsClick(false)
      }, 1000)
    }
  }
  const getLike = async() => {
    let params = {
      cookieCode: webcookie.getCookie('newCode'+lang),
      cancel: false
    }
    apiAsia.waterFall.isLike(params).then(res => {
      if (!!res[0]) {
        let data = JSON.parse(JSON.stringify(list))
        let ids = data.map(v => v.id);
        res[0].forEach(item => {
          if( ids.indexOf(item.itemId)!=-1 ){
            data[ids.indexOf(item.itemId)].isLike = true
          }
        })
        apiAsia.waterFall.list(null,{itemIds:ids, language:lang}).then(res => {
          if (!!res[0]) {
            res[0].forEach(item => {
              if(ids.indexOf(item.itemId)!=-1){
                if(item.count>999){
                  data[ids.indexOf(item.itemId)].likeOther = formatDecimal(item.count/1000,1)+'k'
                }
                data[ids.indexOf(item.itemId)].like = item.count
              }
            })
            setListData(data)
          }
        });
      }
    })
    .catch(err => {
      setToastShow(true)
      setToastTip("点赞数量加载失败")
      setTimeout(()=>{
        setToastShow(false)
      },3000)
    });
  }
  useEffect(() => {
    getMacy()
    window.addEventListener("resize", getMacy);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", getMacy);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [total]);
  useEffect(() => {
    setListData(list)
    getLike()
    return () => {
      clearInterval(timer.current);
    };
  }, []);
  
let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "none",
bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "none",
size = titleSize ? titleSize?.fields?.phrase?.value : "default",
otherSize = desSize ? desSize?.fields?.phrase?.value : "default";
const waterClasses = classNames("padding-top-" + top, "padding-bottom-" + bottom);
return (
  <div className={classNames("water-fall grid",waterClasses)} ref={rootEl}>
    <div className="water-fall__content">
      { ((isMobile && desMobile) || (!isMobile && des)) &&
        <RichText className={classNames("water-fall__des __ff-lk-tp-r",otherSize)} tag="div" field={isMobile ? desMobile : des} />
      }
      <div className="water-fall__list">
        { listData.map((item, index) => (
          (index < total) && masonry &&
          <div className="water-fall__list-item" key={index}>
            <WaterFallItem oldPlayerIndex={oldPlayerIndex} playerIndex={playerIndex} itemLoader={itemLoader} videoPlayPressed={videoPlayPressed} like={like} data={item} index={index} />
          </div>
        ))}
      </div>
      { total < list.length && isClick && 
        <Loader />
      }
      {showBtn && <div className="refresh-button-content">
        <PrimaryButton {...buttonProps} />
      </div>}
      { toastShow && 
        <Toast tip={toastTip} />
      }
      { loadingShow && 
        <Loading />
      }
    </div>
  </div>
  );
};
export default WaterFall;
